import Column from '@components/Column';
import styled from '@emotion/styled';
import useKiccEasyCard from '@hooks/easyCard/useKiccEasyCard';
import useProject from '@hooks/useProject';
import More from '@icons/More';
import { PaymentMethod as PaymentMethodType } from '@models/order';
import { useFlow } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SectionTitle from '../common/SectionTitle';
import PAYMENT_METHODS from './constants/paymentMethods';
import usePaymentMethods from './hooks/usePaymentMethods';
import MethodItem from './MethodItem';

/** 결제 수단. 토스 결제위젯을 쓰는 프로젝트는 위젯이 대신 그린다 */
function PaymentMethod() {
    const { t } = useTranslation('order');
    const { push } = useFlow();
    const dispatch = useDispatch();
    const { paymentMethod } = useCalculatedRequest();
    const { otherMethods, mainMethods, showTossPay } = usePaymentMethods();
    const project = useProject();
    const useKicc = useKiccEasyCard();
    if (project?.pgVendor === 'TOSS') {
        return null;
    }
    const isOtherSelected = otherMethods.includes(paymentMethod);
    const handleSelect = (method: PaymentMethodType) => {
        // KICC 간편카드는 시트에서 카드를 고른 뒤에 결제 수단으로 반영한다
        if (method === 'EASY_CARD' && useKicc) {
            push('OrderEasyCardBottomSheet', {});
            return;
        }
        dispatch(orderActions.setPaymentMethod(method));
    };
    return (
        <Container as='section' fullWidth spacing={4}>
            <SectionTitle>{t('paymentMethod.title')}</SectionTitle>
            <Column fullWidth spacing={2}>
                {mainMethods.map((method) => (
                    <MethodItem key={method}
                        icon={PAYMENT_METHODS[method].icon}
                        label={t(PAYMENT_METHODS[method].nameKey)}
                        isSelected={paymentMethod === method}
                        onClick={() => handleSelect(method)} />
                ))}
                {otherMethods.length > 0 && (
                    <MethodItem icon={<More />}
                        label={isOtherSelected
                            ? t(PAYMENT_METHODS[paymentMethod].nameKey)
                            : t('paymentMethod.other')}
                        isSelected={isOtherSelected}
                        onClick={() => push('OrderPaymentMethodBottomSheet', {})} />
                )}
                {showTossPay && (
                    <MethodItem icon={PAYMENT_METHODS.TOSS_PAY.icon}
                        label={t(PAYMENT_METHODS.TOSS_PAY.nameKey)}
                        isSelected={paymentMethod === 'TOSS_PAY'}
                        onClick={() => handleSelect('TOSS_PAY')} />
                )}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

export default PaymentMethod;
